import { createRoute, redirect } from "@tanstack/solid-router";
import { lazy, Suspense } from "solid-js";
import { isDateKey } from "@journal/shared";
import { appRoute } from "./route";

const DayView = lazy(async () => {
  const m = await import("@/features/journal/components/day-view");
  return { default: m.DayView };
});

function DayPage() {
  const params = dayRoute.useParams();
  return (
    <Suspense fallback={null}>
      <DayView dateKey={() => params().date} />
    </Suspense>
  );
}

export const dayRoute = createRoute({
  getParentRoute: () => appRoute,
  path: "/day/$date",
  beforeLoad: ({ params }) => {
    if (!isDateKey(params.date)) {
      // oxlint-disable-next-line no-throw-literal
      throw redirect({ to: "/" });
    }
  },
  component: DayPage,
});
